import { render, staticRenderFns } from "./PanelStructure.vue?vue&type=template&id=666ba81f&"
import script from "./PanelStructure.vue?vue&type=script&lang=js&"
export * from "./PanelStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports